export enum ECommunicationChannelType {
  email = 'email',
  phone = 'phone',
}
export type IEmail = {
  email: string;
};
export type IPhone = {
  phone: string;
};

type ISettings = IEmail | IPhone;

export type ICommunicationChannel<T> = {
  id: string;
  type: ECommunicationChannelType;
  title: string;
  settings: T;
  order: number;
  isEnabled: boolean;
};

export type IBaseCommunicationChannel = {
  id: string;
  type: ECommunicationChannelType;
  title: string;
  settings: ISettings;
  order: number;
  isEnabled: boolean;
};

export type IDefaultCommunicationChannel = {
  id: string;
  type: ECommunicationChannelType;
  title: string;
  settings: ISettings;
};
